<template>
  <div class="ReportOriginatingFees" v-if="isloaded">
    <OriginatingFeesReport :token="token" :userType="ConnecteduserType" />
  </div>
</template>
<script>
window["multirapports"] = window["multirapports"] || {};
export default {
  name: "ReportsPageOriginFees",
  data: () => ({
    token: null,
    isloaded: false,
    ConnecteduserType: "",
  }),
  created() {
    this.ConnecteduserType = localStorage.getItem("userType");
    this.token = sessionStorage.getItem("adal.idtoken");
  },
  mounted() {
    this.isloaded = true;
  },
  components: {
    ...window["multirapports"].default,
  },
};
</script>
<style lang="scss">
.ReportOriginatingFees {
  top: 73px;
  position: relative;
  z-index: 99;
  padding-bottom: 72px;
  width: calc(100% - -19px);
  height: 100%;
  overflow-y: scroll;
  min-height: calc(100vh - 72px);
  overflow-x: hidden !important;
}
@media (max-width: 480px) and (min-width: 320px) {
  .ReportOriginatingFees {
    top: 107px;
    position: relative;
    z-index: 99;
    left: 34px;
    width: calc(100% - 34px);
  }
}
@media print {
  .ReportOriginatingFees {
    left: 0px !important;
    overflow-y: hidden !important;
  }
}
@media (max-width: 640px) and (min-width: 480px) {
  .ReportOriginatingFees {
    top: 107px;
    position: relative;
    z-index: 99;
    left: 34px;
    width: calc(100% - 34px);
  }
}
@media (max-width: 768px) and (min-width: 640px) {
  .ReportOriginatingFees {
    top: 107px;
    position: relative;
    z-index: 99;
    left: 34px;
    width: calc(100% - 34px);
  }
}
</style>
